/*
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
var StaticDataProvider = /** @class */ (function (_super) {
    __extends(StaticDataProvider, _super);
    function StaticDataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StaticDataProvider.prototype.render = function () {
        return [];
    };
    return StaticDataProvider;
}(React.Component));
export { StaticDataProvider };
